import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import padding from "@irati/ui/src/global/padding"
import media from "@irati/ui/src/global/media"

const commonCardCss = css`
  border-radius: 0 0 3px 3px;
  padding: ${padding.medium} ${padding.base} ${padding.small} ${padding.base};
  box-shadow: none;
  border-bottom: 5px solid transparent;
  ${media.desktop`
    padding: ${padding.medium} ${padding.base} ${padding.small} ${padding.base};
  `}

  ${media.tablet`
    padding: 25px ${padding.small} 10px ${padding.small};
  `}
`

interface AvailableCardProps {
  borderBottomColor: string
}

export const AvailableCardDeal = styled(Card)<AvailableCardProps>`
  ${commonCardCss}
  ${({borderBottomColor}) => borderBottomColor && `
    border-bottom-color: ${borderBottomColor};
  `}
`

export const UnavailableCardDeal = styled(Card)`
  ${commonCardCss}
  ${({theme}) => `background-color: ${theme.colors.greys.mediumLight}};`}
`
